{
  "pro-locked": "pro-locked_AWpVDcBcK.svg",
  "printing-invoices": "pro-locked_AWpVDcBcK.svg"
}
